import React from 'react';
import { Card,
        Pic,
        Type,
        Title,
        Description,
        WrapperPrice,
        Price,
        PriceText,
        Button,
        Free,
        PromoPrice,
        Wrapper,
        Discount,
        Select,
        CameraDescription } from './styled';
import { connect } from 'react-redux';

class LotCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedOption: this.getOptions(this.props.data)[0],
        };
    }

    percentCount = (price, promoPrice) => {
        const onePercent = price / 100;
        const newPrice = promoPrice / onePercent;
        const comparePercent = 100 - newPrice;
        const percent = Math.round(comparePercent);
        return ('-' + percent + '%');
    }

    getData = (data) => {
        const obj = {};
        data.map(item => {
            obj[item.name] = item.value;
        });
        return obj;
    }

    getOptions = (data) => {
        const options = [];
        const obj = this.getData(data);
        if (obj.duration_1 && obj.leasing_price_1) {
            options.push({
                value: obj.duration_1,
                label: `при рассрочке ${obj.duration_1} мес.`,
                price: obj.leasing_price_1,
                operType: 5
            });
        }
        if (obj.duration_2 && obj.leasing_price_2) {
            options.push({
                value: obj.duration_2,
                label: `при рассрочке ${obj.duration_2} мес.`,
                price: obj.leasing_price_2,
                operType: 5
            });
        }
        if (obj.duration_3 && obj.leasing_price_3) {
            options.push({
                value: obj.duration_3,
                label: `при рассрочке ${obj.duration_3} мес.`,
                price: obj.leasing_price_3,
                operType: 5
            });
        }
        if (obj.duration_4 && obj.leasing_price_4) {
            options.push({
                value: obj.duration_4,
                label: `при рассрочке ${obj.duration_4} мес.`,
                price: obj.leasing_price_4,
                operType: 5
            });
        }
        options.push({
            label: 'при покупке',
            price: this.props.promoPrice ? this.props.promoPrice : this.props.price,
            operType: 1
        });
        return options;
    }

    changeOptions = (option) => {
        this.setState({
            selectedOption: option,
        });
    }

    render() {
        const { selectedOption } = this.state;
        const { description, name, price, button_text, image, type, promoPrice, data, onClickButtonHandlerForCard } = this.props;
        return (
            <React.Fragment>
                <Card>
                    <Pic background={`url(${image})`}/>
                    <Type>
                        {this.getData(data).category}
                    </Type>
                    <Title>
                        {name}
                    </Title>
                    <CameraDescription>
                        {this.getData(data).description}
                    </CameraDescription>
                    {type === 3 && <Free>бесплатно доставим и настроим</Free>}
                    <WrapperPrice>
                        {selectedOption.label === 'при покупке' && promoPrice &&
                        <Wrapper>
                            <PromoPrice>
                                {price}
                            </PromoPrice>
                            <Discount>
                                {this.percentCount(price, promoPrice)}
                            </Discount>
                        </Wrapper>}
                        <Wrapper>
                            <Price>
                                {selectedOption.price}
                            </Price>
                            <PriceText>
                                {selectedOption.label !== 'при покупке' ? '₽/мес' : '₽'}
                            </PriceText>
                            <Select options={this.getOptions(data)} minWidth='220px' value={selectedOption} onChange={this.changeOptions}/>
                        </Wrapper>
                    </WrapperPrice>
                    <Description dangerouslySetInnerHTML={{ __html: description }}/>
                    <Button text={button_text} onClick={onClickButtonHandlerForCard}/>
                </Card>
            </React.Fragment>
        );
    }

}

const mapStateToProps = state => ({
    auth: state.auth,
    currentCity: state.city.currentCity,
});

export default connect(mapStateToProps)(LotCard);
